import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

import './style.scss';

const ViewCrisisBanner = ({ entities, forwardRef }) => {
  if (entities.size === 0) {
    return null;
  }

  return (
    <div className="ViewCrisisBanner" ref={forwardRef}>
      {entities.map((entity) => {
        const id = entity.getIn(['nid', '0', 'value']);
        const uuid = entity.getIn(['uuid', 0, 'value']);
        const langcode = entity.getIn(['langcode', 0, 'value']);
        return (
          <div key={`${uuid}:${langcode}`}>
            <Node
              id={id}
              key={`${uuid}:${langcode}`}
              entity={entity}
              viewMode="teaser"
            />
          </div>
        );
      })}
    </div>
  );
};

export default ViewCrisisBanner;
